import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_FIELD_BEGIN,
  COLLECTIONS_DELETE_FIELD_SUCCESS,
  COLLECTIONS_DELETE_FIELD_FAILURE,
  COLLECTIONS_DELETE_FIELD_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteField(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_FIELD_BEGIN,
    });
    const { projectId, collectionName, fieldId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${collectionName}/fields/${fieldId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_FIELD_SUCCESS,
              data: res.data,
              collectionName: args.collectionName,
            });
            Mixpanel.track('Deleted collection field', {
              collectionName: collectionName,
              uuid: fieldId,
            });
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_FIELD_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection field');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion Failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_FIELD_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection field');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteFieldError() {
  return {
    type: COLLECTIONS_DELETE_FIELD_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_FIELD_BEGIN:
      return {
        ...state,
        deleteFieldPending: true,
        deleteFieldError: null,
      };

    case COLLECTIONS_DELETE_FIELD_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.collectionName === action.collectionName;
      });
      projectCollections[index].fields = action.data.fields;
      return {
        ...state,
        deleteFieldPending: false,
        deleteFieldError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          fields: action.data.fields,
        },
      };

    case COLLECTIONS_DELETE_FIELD_FAILURE:
      return {
        ...state,
        deleteFieldPending: false,
        deleteFieldError: action.data.error,
      };

    case COLLECTIONS_DELETE_FIELD_DISMISS_ERROR:
      return {
        ...state,
        deleteFieldError: null,
      };

    default:
      return state;
  }
}
